import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Divider property - Definition */
export class DocsBlockDividerPropertyDefinition extends DocsBlockPropertyDefinition {
}
